module.exports = __webpack_public_path__ + "media/images/icons/youtube-2f7dda520aba49d3038d95aee9898ebb.svg";